<div
  class="modal fade"
  id="exampleModalFamily"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-danger fw-bold" id="exampleModalLabel">
          ⚠️ {{ 'family_delete_confirmation.title' | transloco }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body w-100 px-4">
        <div class="container py-3">
          <p [innerHTML]="'family_delete_confirmation.message' | transloco"></p>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline-secondary" (click)="closeModal()">
          {{ 'cancel' | transloco }}
        </button>

        <button class="btn btn-danger" (click)="delete()">{{ 'family_delete_confirmation.confirm' | transloco }}</button>
      </div>
    </div>
  </div>
</div>
